import { useQuery } from '@tanstack/react-query'
import { useApi } from '../api/contexto'
import type { ErrorApi } from '../api/errores'
import type { Integraciones } from '../api/modelos'

/**
 * Estado de las integraciones (RF-37). Lo leen el menú (Workflows solo con n8n)
 * y las acciones que dependen de un servicio (geocodificar).
 */
export function useIntegraciones() {
  const api = useApi()
  return useQuery<Integraciones, ErrorApi>({
    queryKey: ['integraciones'],
    queryFn: ({ signal }) => api.pedir<Integraciones>('/api/integraciones', { senal: signal }),
    staleTime: 5 * 60_000,
  })
}
